import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from "antd";
import { removeSessionStorage, mobileAndTabletCheck } from "../tools";
import { ErrorPage } from "../components/shared/ErrorPage";
import { SpinnerRegione } from "../components/shared/SpinnerRegione";
import { Notification } from "../components/shared/Notification";
import { getConfig, getConfigStore, fetchConfigEnded, isMobileMode, setMobileMode } from "../modules/configuration";
import { getLocale, getMessages, getLocaleInfo, IT, EN } from "../modules/language";
import { SwitchContent } from "./SwitchContent";
import moment from "moment";
import "moment/locale/it";
import en from "antd/lib/locale/en_US";
import it from "antd/lib/locale/it_IT";

const BASENAME = "/surgerytracker";
moment.locale("it");

export const App = () => {
  const dispatch = useDispatch();
  const config = useSelector(getConfigStore);
  const configLoaded = useSelector(fetchConfigEnded);
  const mobileMode = useSelector(isMobileMode);
  const messages = useSelector(getMessages);
  const locale = useSelector(getLocale);
  const [waitingComplete, setWaitingComplete] = useState(false);
  const [localeConfigProvider, setLocaleConfigProvider] = useState(it);

  // Rimuovo il token per le chiamate api e il flag per visualizzare il popup dei cookie
  useEffect(() => {
    window.addEventListener(
      "beforeunload",
      () => {
        removeSessionStorage();
      },
      false
    );

    return function cleanup() {
      window.removeEventListener("beforeunload", () => removeSessionStorage(), false);
    };
    // eslint-disable-next-line
  }, []);

  // Rilevo se la navigazione avviene da mobile
  useEffect(() => {
    // prettier-ignore
    window.addEventListener("resize",() => {
      const checkMobile = mobileAndTabletCheck();
      if (checkMobile !== mobileMode) dispatch(setMobileMode(checkMobile));
    }, false);
  }, [mobileMode, dispatch]);

  useEffect(() => {
    if (!config && !configLoaded) dispatch(getConfig());
    if (config && configLoaded && !locale) dispatch(getLocaleInfo());
    if (messages && messages !== undefined && !waitingComplete) setWaitingComplete(true);
    if (locale && !waitingComplete) {
      const timeout = setTimeout(() => {
        setWaitingComplete(true);
      }, 1000);
      return () => clearTimeout(timeout);
    }
  }, [config, configLoaded, locale, waitingComplete, messages, dispatch]);

  useEffect(() => {
    if (locale === IT) {
      setLocaleConfigProvider(it);
      moment.locale("it");
    } else if (locale === EN) {
      setLocaleConfigProvider(en);
      moment.locale("en");
    }
  }, [locale]);

  return locale && waitingComplete ? (
    configLoaded ? (
      <ConfigProvider locale={localeConfigProvider}>
        <IntlProvider messages={messages} locale={locale} defaultLocale={config.defaultLanguage}>
          <Notification />
          <Router basename={BASENAME}>
            <SwitchContent />
          </Router>
        </IntlProvider>
      </ConfigProvider>
    ) : (
      <ErrorPage />
    )
  ) : (
    <SpinnerRegione />
  );
};
